
































































































































































































































import UserAuthority from '@/domain/security/user-authority.service';
import Contract from '@/domain/contract/entity/contract.entity';
import Csm from '@/domain/csm/entity/csm.entity';
import CsmService from '@/domain/csm/service/csm.service';
import LeadOrigin from '@/domain/lead-origin/entity/lead-origin.entity';
import LeadOriginService from '@/domain/lead-origin/service/lead-origin.service';
import LeadSource from '@/domain/lead-source/entity/lead-source.entity';
import LeadSourceService from '@/domain/lead-source/service/lead-source.service';
import Segment from '@/domain/segment/entity/segment.entity';
import SegmentService from '@/domain/segment/service/segment.service';
import Seller from '@/domain/seller/entity/seller.entity';
import SellerService from '@/domain/seller/service/seller.service';
import AutoCompleteAddItemComponent
  from '@/shared/autocomplete-add-item/autocomplete-add-item.component.vue';
import MainButton from '@/shared/buttons/main-button.component.vue';
import Rules from '@/shared/rules/rules';
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import FeatureService from '@/domain/feature/service/feature.service';
import CompetingFirmService from '@/domain/competing-firm/service/competing-firm.service';
import IntegrationTypeService from '@/domain/integration-type/service/integration-type.service';
import PortfolioService from '@/domain/portfolio/service/portfolio.service';
import Portfolio from '@/domain/portfolio/entity/portfolio.entity';
import IntegrationType from '@/domain/integration-type/entity/integration-type.entity';
import CompetingFirm from '@/domain/competing-firm/entity/competing-firm.entity';
import Feature from '@/domain/feature/entity/feature.entity';
import ContractService from '@/domain/contract/service/contract.service';
import ContractAdditionalInfoRequest from '@/domain/contract/request/contract-additional-info-request.entity';
import ContractInfoTabControl from '../contract-info-tab-index';

@Component({
  components: {
    VbTooltipSlot,
    AutoCompleteAddItemComponent,
    MainButton,
  },
})
export default class AdditionalInfoComponent extends Vue {
  @Prop({ required: true })
  tabControl!: ContractInfoTabControl;

  @Prop({ required: true })
  contract!: Contract;

  @Prop({ required: true })
  userAuthority!: UserAuthority;

  @Prop({ required: true })
  businessUnitId!: string;

  @Prop({ required: false, default: false })
  loadElements!: boolean;

  $refs!: any;

  rules: Rules = new Rules();

  editModeValue: boolean = false;

  contractAdditionalInfoRequest: ContractAdditionalInfoRequest =
    new ContractAdditionalInfoRequest();

  csms: Csm[] = [];

  segments: Segment[] = [];

  sellers: Seller[] = [];

  leadSources: LeadSource[] = [];

  leadOrigins: LeadOrigin[] = [];

  features: Feature[] = [];

  portfolios: Portfolio[] = [];

  potentials: Portfolio[] = [];

  integrationTypes: IntegrationType[] = [];

  competingFirms: CompetingFirm[] = [];

  addElementToAutocomplete: boolean = false;

  loading: boolean = false;

  created() {
    if (this.loadElements) this.getLists();
  }

  checkPermissionEditContract(): boolean {
    return this.userAuthority.canEditContract();
  }

  checkPermissionEditPortfolio(): boolean {
    return this.userAuthority.isAdministrator() || this.userAuthority.isAuditor();
  }

  updateFieldsDefault() {
    const additionalData = this.contract.contractAdditionalData;
    this.contractAdditionalInfoRequest.csm = additionalData.csm;
    this.contractAdditionalInfoRequest.segment = additionalData.segment;
    this.contractAdditionalInfoRequest.seller = additionalData.seller;
    this.contractAdditionalInfoRequest.leadSource = additionalData.leadSource;
    this.contractAdditionalInfoRequest.leadOrigin = additionalData.leadOrigin;
    this.contractAdditionalInfoRequest.features = this.contract.cancellationRequest.features;
    this.contractAdditionalInfoRequest.portfolio = additionalData.portfolio;
    this.contractAdditionalInfoRequest.potential = additionalData.potential;
    this.contractAdditionalInfoRequest.avgMonthlySales = additionalData.avgMonthlySales;
    this.contractAdditionalInfoRequest.healthScore = additionalData.healthScore;
    this.contractAdditionalInfoRequest.nps = additionalData.nps;
    this.contractAdditionalInfoRequest.integrationType = additionalData.integrationType;
    this.contractAdditionalInfoRequest.competingFirm = additionalData.competingFirm;
  }

  updateSegments(value: any) {
    this.contractAdditionalInfoRequest.segment = value;
  }

  updateFeatures(value: any) {
    this.contractAdditionalInfoRequest.features = value;
  }

  updateCsms(value: any) {
    this.contractAdditionalInfoRequest.csm = value;
  }

  updateSellers(value: any) {
    this.contractAdditionalInfoRequest.seller = value;
  }

  updateLeadSources(value: any) {
    this.contractAdditionalInfoRequest.leadSource = value;
  }

  updateLeadOrigins(value: any) {
    this.contractAdditionalInfoRequest.leadOrigin = value;
  }

  updatePortfolios(value: any) {
    this.contractAdditionalInfoRequest.portfolio = value;
  }

  updatePotentials(value: any) {
    this.contractAdditionalInfoRequest.potential = value;
  }

  updateIntegrationTypes(value: any) {
    this.contractAdditionalInfoRequest.integrationType = value;
  }

  updateCompetingFirms(value: any) {
    this.contractAdditionalInfoRequest.competingFirm = value;
  }

  enableEdition() {
    this.editModeValue = !this.editModeValue;
    if (!this.loadElements) {
      this.getLists();
    }
  }

  cancel() {
    this.editModeValue = !this.editModeValue;
  }

  clickSave() {
    if (!this.editModeValue) {
      return this.enableEdition();
    }
    if (!this.$refs.form.validate()) {
      return this;
    }
    ContractService
      .updateContractAdditionalInfo(
        this.businessUnitId,
        this.contract.id,
        this.contractAdditionalInfoRequest,
      )
      .then(() => {
        VbSnackbarService.showSuccess('Informações adicionais atualizadas com sucesso')
        this.editModeValue = !this.editModeValue;
      })
      .catch(VbSnackbarService.handleHttpError)
    return this;
  }

  @Watch('tabControl')
  getLists() {
    if (this.tabControl !== ContractInfoTabControl.INFORMACOES_ADICIONAIS) {
      return
    }
    this.updateFieldsDefault();
    this.loading = true;
    this.getCsms();
    this.getSegments();
    this.getSellers();
    this.getLeadOrigins();
    this.getLeadSources();
    this.getPortfolios();
    this.getPotentials();
    this.getIntegrationTypes();
    this.getCompetingFirms();
    this.getFeatures();
    this.loading = false;
  }

  getCsms() {
    CsmService.getCsms()
      .then((response: Csm[]) => this.csms = response)
      .catch(VbSnackbarService.handleHttpError);
  }

  getSegments() {
    SegmentService.getSegments()
      .then((response: Segment[]) => this.segments = response)
      .catch(VbSnackbarService.handleHttpError);
  }

  getSellers() {
    SellerService.getSellers()
      .then((response: Seller[]) => this.sellers = response)
      .catch(VbSnackbarService.handleHttpError);
  }

  getLeadSources() {
    LeadSourceService.getLeadSources()
      .then((response: LeadSource[]) => this.leadSources = response)
      .catch(VbSnackbarService.handleHttpError);
  }

  getLeadOrigins() {
    LeadOriginService.getLeadOrigins()
      .then((response: LeadOrigin[]) => this.leadOrigins = response)
      .catch(VbSnackbarService.handleHttpError);
  }

  getPortfolios() {
    PortfolioService.getPortfolios(this.businessUnitId, 'PORTFOLIO')
      .then((response: Portfolio[]) => this.portfolios = response)
      .catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  getPotentials() {
    PortfolioService.getPortfolios(this.businessUnitId, 'POTENTIAL')
      .then((response: Portfolio[]) => this.potentials = response)
      .catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  getIntegrationTypes() {
    IntegrationTypeService.getIntegrationTypes()
      .then((response: IntegrationType[]) => this.integrationTypes = response)
      .catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  getCompetingFirms() {
    CompetingFirmService.getCompetingFirms()
      .then((response: CompetingFirm[]) => this.competingFirms = response)
      .catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  getFeatures() {
    FeatureService.getFeatures(this.businessUnitId)
      .then((response: Feature[]) => this.features = response)
      .catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  getTextButtonSave() {
    return this.editModeValue ? 'Salvar' : 'Editar';
  }

  addCsm(params: any) {
    const { elementName, addElement } = params;
    this.addElementToAutocomplete = addElement;
    const csmToAdd: Csm = { name: elementName };

    CsmService.create(csmToAdd)
      .then((addedCsm: Csm) => {
        this.csms.unshift(addedCsm);
        this.contract.contractAdditionalData.csm = addedCsm;
      })
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => {
        this.addElementToAutocomplete = false;
      });
  }

  addSegment(params: any) {
    const { elementName, addElement } = params;
    this.addElementToAutocomplete = addElement;
    const segmentToAdd: Segment = { name: elementName };

    SegmentService.create(segmentToAdd)
      .then((addedSegment: Segment) => {
        this.segments.unshift(addedSegment);
        this.contract.contractAdditionalData.segment = addedSegment;
      })
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => {
        this.addElementToAutocomplete = false;
      });
  }

  addSeller(params: any) {
    const { elementName, addElement } = params;
    this.addElementToAutocomplete = addElement;
    const sellerToAdd: Seller = { name: elementName };

    SellerService.create(sellerToAdd)
      .then((addedSeller: Seller) => {
        this.sellers.unshift(addedSeller);
        this.contract.contractAdditionalData.seller = addedSeller;
      })
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => {
        this.addElementToAutocomplete = false;
      });
  }

  addLeadSource(params: any) {
    const { elementName, addElement } = params;
    this.addElementToAutocomplete = addElement;
    const leadSourceToAdd: LeadSource = { name: elementName };

    LeadSourceService.create(leadSourceToAdd)
      .then((addedLeadSource: LeadSource) => {
        this.leadSources.unshift(addedLeadSource);
        this.contract.contractAdditionalData.leadSource = addedLeadSource;
      })
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => {
        this.addElementToAutocomplete = false;
      });
  }

  addLeadOrigin(params: any) {
    const { elementName, addElement } = params;
    this.addElementToAutocomplete = addElement;
    const leadOriginToAdd: LeadOrigin = { name: elementName };

    LeadOriginService.create(leadOriginToAdd)
      .then((addedLeadOrigin: LeadOrigin) => {
        this.leadOrigins.unshift(addedLeadOrigin);
        this.contract.contractAdditionalData.leadOrigin = addedLeadOrigin;
      })
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => {
        this.addElementToAutocomplete = false;
      });
  }

  addIntegrationType(params: any) {
    const { elementName, addElement } = params;
    this.addElementToAutocomplete = addElement;
    const integrationTypeToAdd: IntegrationType = { name: elementName };

    IntegrationTypeService.create(integrationTypeToAdd)
      .then((addedIntegrationType: IntegrationType) => {
        this.integrationTypes.unshift(addedIntegrationType);
        this.contract.contractAdditionalData.integrationType = addedIntegrationType;
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => {
        this.addElementToAutocomplete = false;
      });
  }

  addCompetingFirm(params: any) {
    const { elementName, addElement } = params;
    this.addElementToAutocomplete = addElement;
    const competingFirmToAdd: CompetingFirm = { name: elementName };

    CompetingFirmService.create(competingFirmToAdd)
      .then((addedCompetingFirm: CompetingFirm) => {
        this.competingFirms.unshift(addedCompetingFirm);
        this.contract.contractAdditionalData.competingFirm = addedCompetingFirm;
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => {
        this.addElementToAutocomplete = false;
      });
  }

  addFeature(params: any) {
    const { elementName, addElement } = params;
    this.addElementToAutocomplete = addElement;
    const featureToAdd: Feature = {
      name: elementName,
      businessUnitId: this.businessUnitId,
    };

    FeatureService.create(featureToAdd)
      .then((addedFeature: Feature) => {
        this.features.unshift(addedFeature);
        this.contract.cancellationRequest.features.unshift(addedFeature);
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => {
        this.addElementToAutocomplete = false;
      });
  }
}
